import M from 'messages';

// Partner Type options (from serviceProviders.type enum)
export const partnerTypeOptions = [
  {
    value: 'Winery',
    title: M.get('campaigns.filters.partnerType.winery'),
    label: M.get('campaigns.filters.partnerType.winery'),
  },
  {
    value: 'Restaurant',
    title: M.get('campaigns.filters.partnerType.restaurant'),
    label: M.get('campaigns.filters.partnerType.restaurant'),
  },
  {
    value: 'Event Organizer',
    title: M.get('campaigns.filters.partnerType.eventOrganizer'),
    label: M.get('campaigns.filters.partnerType.eventOrganizer'),
  },
  {
    value: 'Hotel',
    title: M.get('campaigns.filters.partnerType.hotel'),
    label: M.get('campaigns.filters.partnerType.hotel'),
  },
  {
    value: 'Wine Bar',
    title: M.get('campaigns.filters.partnerType.wineBar'),
    label: M.get('campaigns.filters.partnerType.wineBar'),
  },
  {
    value: 'Retailer',
    title: M.get('campaigns.filters.partnerType.retailer'),
    label: M.get('campaigns.filters.partnerType.retailer'),
  },
];

// Partner Audience options for WineLovers
export const partnerAudienceOptions = [
  {
    value: 'followers',
    title: M.get('campaigns.filters.partnerAudience.followers'),
    label: M.get('campaigns.filters.partnerAudience.followers'),
  },
  {
    value: 'rated',
    title: M.get('campaigns.filters.partnerAudience.rated'),
    label: M.get('campaigns.filters.partnerAudience.rated'),
  },
  {
    value: 'saved',
    title: M.get('campaigns.filters.partnerAudience.saved'),
    label: M.get('campaigns.filters.partnerAudience.saved'),
  },
];

// State options (US states)
export const stateOptions = [
  { value: 'AL', title: 'Alabama', label: 'Alabama' },
  { value: 'AK', title: 'Alaska', label: 'Alaska' },
  { value: 'AZ', title: 'Arizona', label: 'Arizona' },
  { value: 'AR', title: 'Arkansas', label: 'Arkansas' },
  { value: 'CA', title: 'California', label: 'California' },
  { value: 'CO', title: 'Colorado', label: 'Colorado' },
  { value: 'CT', title: 'Connecticut', label: 'Connecticut' },
  { value: 'DE', title: 'Delaware', label: 'Delaware' },
  { value: 'FL', title: 'Florida', label: 'Florida' },
  { value: 'GA', title: 'Georgia', label: 'Georgia' },
  { value: 'HI', title: 'Hawaii', label: 'Hawaii' },
  { value: 'ID', title: 'Idaho', label: 'Idaho' },
  { value: 'IL', title: 'Illinois', label: 'Illinois' },
  { value: 'IN', title: 'Indiana', label: 'Indiana' },
  { value: 'IA', title: 'Iowa', label: 'Iowa' },
  { value: 'KS', title: 'Kansas', label: 'Kansas' },
  { value: 'KY', title: 'Kentucky', label: 'Kentucky' },
  { value: 'LA', title: 'Louisiana', label: 'Louisiana' },
  { value: 'ME', title: 'Maine', label: 'Maine' },
  { value: 'MD', title: 'Maryland', label: 'Maryland' },
  { value: 'MA', title: 'Massachusetts', label: 'Massachusetts' },
  { value: 'MI', title: 'Michigan', label: 'Michigan' },
  { value: 'MN', title: 'Minnesota', label: 'Minnesota' },
  { value: 'MS', title: 'Mississippi', label: 'Mississippi' },
  { value: 'MO', title: 'Missouri', label: 'Missouri' },
  { value: 'MT', title: 'Montana', label: 'Montana' },
  { value: 'NE', title: 'Nebraska', label: 'Nebraska' },
  { value: 'NV', title: 'Nevada', label: 'Nevada' },
  { value: 'NH', title: 'New Hampshire', label: 'New Hampshire' },
  { value: 'NJ', title: 'New Jersey', label: 'New Jersey' },
  { value: 'NM', title: 'New Mexico', label: 'New Mexico' },
  { value: 'NY', title: 'New York', label: 'New York' },
  { value: 'NC', title: 'North Carolina', label: 'North Carolina' },
  { value: 'ND', title: 'North Dakota', label: 'North Dakota' },
  { value: 'OH', title: 'Ohio', label: 'Ohio' },
  { value: 'OK', title: 'Oklahoma', label: 'Oklahoma' },
  { value: 'OR', title: 'Oregon', label: 'Oregon' },
  { value: 'PA', title: 'Pennsylvania', label: 'Pennsylvania' },
  { value: 'RI', title: 'Rhode Island', label: 'Rhode Island' },
  { value: 'SC', title: 'South Carolina', label: 'South Carolina' },
  { value: 'SD', title: 'South Dakota', label: 'South Dakota' },
  { value: 'TN', title: 'Tennessee', label: 'Tennessee' },
  { value: 'TX', title: 'Texas', label: 'Texas' },
  { value: 'UT', title: 'Utah', label: 'Utah' },
  { value: 'VT', title: 'Vermont', label: 'Vermont' },
  { value: 'VA', title: 'Virginia', label: 'Virginia' },
  { value: 'WA', title: 'Washington', label: 'Washington' },
  { value: 'WV', title: 'West Virginia', label: 'West Virginia' },
  { value: 'WI', title: 'Wisconsin', label: 'Wisconsin' },
  { value: 'WY', title: 'Wyoming', label: 'Wyoming' },
];

// Country options (will be loaded from backend)
export const countryOptions = [
  {
    Country: 'Afghanistan',
    'Alpha-2': 'AF',
    'Alpha-3': 'AFG',
    Numeric: 4,
    ISO: 'ISO 3166-2:AF',
    Independent: true,
  },
  {
    Country: '\u00c5land Islands',
    'Alpha-2': 'AX',
    'Alpha-3': 'ALA',
    Numeric: 248,
    ISO: 'ISO 3166-2:AX',
    Independent: false,
  },
  {
    Country: 'Albania',
    'Alpha-2': 'AL',
    'Alpha-3': 'ALB',
    Numeric: 8,
    ISO: 'ISO 3166-2:AL',
    Independent: true,
  },
  {
    Country: 'Algeria',
    'Alpha-2': 'DZ',
    'Alpha-3': 'DZA',
    Numeric: 12,
    ISO: 'ISO 3166-2:DZ',
    Independent: true,
  },
  {
    Country: 'American Samoa',
    'Alpha-2': 'AS',
    'Alpha-3': 'ASM',
    Numeric: 16,
    ISO: 'ISO 3166-2:AS',
    Independent: false,
  },
  {
    Country: 'Andorra',
    'Alpha-2': 'AD',
    'Alpha-3': 'AND',
    Numeric: 20,
    ISO: 'ISO 3166-2:AD',
    Independent: true,
  },
  {
    Country: 'Angola',
    'Alpha-2': 'AO',
    'Alpha-3': 'AGO',
    Numeric: 24,
    ISO: 'ISO 3166-2:AO',
    Independent: true,
  },
  {
    Country: 'Anguilla',
    'Alpha-2': 'AI',
    'Alpha-3': 'AIA',
    Numeric: 660,
    ISO: 'ISO 3166-2:AI',
    Independent: false,
  },
  {
    Country: 'Antarctica',
    'Alpha-2': 'AQ',
    'Alpha-3': 'ATA',
    Numeric: 10,
    ISO: 'ISO 3166-2:AQ',
    Independent: false,
  },
  {
    Country: 'Antigua and Barbuda',
    'Alpha-2': 'AG',
    'Alpha-3': 'ATG',
    Numeric: 28,
    ISO: 'ISO 3166-2:AG',
    Independent: true,
  },
  {
    Country: 'Argentina',
    'Alpha-2': 'AR',
    'Alpha-3': 'ARG',
    Numeric: 32,
    ISO: 'ISO 3166-2:AR',
    Independent: true,
  },
  {
    Country: 'Armenia',
    'Alpha-2': 'AM',
    'Alpha-3': 'ARM',
    Numeric: 51,
    ISO: 'ISO 3166-2:AM',
    Independent: true,
  },
  {
    Country: 'Aruba',
    'Alpha-2': 'AW',
    'Alpha-3': 'ABW',
    Numeric: 533,
    ISO: 'ISO 3166-2:AW',
    Independent: false,
  },
  {
    Country: 'Australia',
    'Alpha-2': 'AU',
    'Alpha-3': 'AUS',
    Numeric: 36,
    ISO: 'ISO 3166-2:AU',
    Independent: true,
  },
  {
    Country: 'Austria',
    'Alpha-2': 'AT',
    'Alpha-3': 'AUT',
    Numeric: 40,
    ISO: 'ISO 3166-2:AT',
    Independent: true,
  },
  {
    Country: 'Azerbaijan',
    'Alpha-2': 'AZ',
    'Alpha-3': 'AZE',
    Numeric: 31,
    ISO: 'ISO 3166-2:AZ',
    Independent: true,
  },
  {
    Country: 'Bahamas',
    'Alpha-2': 'BS',
    'Alpha-3': 'BHS',
    Numeric: 44,
    ISO: 'ISO 3166-2:BS',
    Independent: true,
  },
  {
    Country: 'Bahrain',
    'Alpha-2': 'BH',
    'Alpha-3': 'BHR',
    Numeric: 48,
    ISO: 'ISO 3166-2:BH',
    Independent: true,
  },
  {
    Country: 'Bangladesh',
    'Alpha-2': 'BD',
    'Alpha-3': 'BGD',
    Numeric: 50,
    ISO: 'ISO 3166-2:BD',
    Independent: true,
  },
  {
    Country: 'Barbados',
    'Alpha-2': 'BB',
    'Alpha-3': 'BRB',
    Numeric: 52,
    ISO: 'ISO 3166-2:BB',
    Independent: true,
  },
  {
    Country: 'Belarus',
    'Alpha-2': 'BY',
    'Alpha-3': 'BLR',
    Numeric: 112,
    ISO: 'ISO 3166-2:BY',
    Independent: true,
  },
  {
    Country: 'Belgium',
    'Alpha-2': 'BE',
    'Alpha-3': 'BEL',
    Numeric: 56,
    ISO: 'ISO 3166-2:BE',
    Independent: true,
  },
  {
    Country: 'Belize',
    'Alpha-2': 'BZ',
    'Alpha-3': 'BLZ',
    Numeric: 84,
    ISO: 'ISO 3166-2:BZ',
    Independent: true,
  },
  {
    Country: 'Benin',
    'Alpha-2': 'BJ',
    'Alpha-3': 'BEN',
    Numeric: 204,
    ISO: 'ISO 3166-2:BJ',
    Independent: true,
  },
  {
    Country: 'Bermuda',
    'Alpha-2': 'BM',
    'Alpha-3': 'BMU',
    Numeric: 60,
    ISO: 'ISO 3166-2:BM',
    Independent: false,
  },
  {
    Country: 'Bhutan',
    'Alpha-2': 'BT',
    'Alpha-3': 'BTN',
    Numeric: 64,
    ISO: 'ISO 3166-2:BT',
    Independent: true,
  },
  {
    Country: 'Bolivia',
    'Alpha-2': 'BO',
    'Alpha-3': 'BOL',
    Numeric: 68,
    ISO: 'ISO 3166-2:BO',
    Independent: true,
  },
  {
    Country: 'Bonaire Sint Eustatius and Saba',
    'Alpha-2': 'BQ',
    'Alpha-3': 'BES',
    Numeric: 535,
    ISO: 'ISO 3166-2:BQ',
    Independent: false,
  },
  {
    Country: 'Bosnia and Herzegovina',
    'Alpha-2': 'BA',
    'Alpha-3': 'BIH',
    Numeric: 70,
    ISO: 'ISO 3166-2:BA',
    Independent: true,
  },
  {
    Country: 'Botswana',
    'Alpha-2': 'BW',
    'Alpha-3': 'BWA',
    Numeric: 72,
    ISO: 'ISO 3166-2:BW',
    Independent: true,
  },
  {
    Country: 'Bouvet Island',
    'Alpha-2': 'BV',
    'Alpha-3': 'BVT',
    Numeric: 74,
    ISO: 'ISO 3166-2:BV',
    Independent: false,
  },
  {
    Country: 'Brazil',
    'Alpha-2': 'BR',
    'Alpha-3': 'BRA',
    Numeric: 76,
    ISO: 'ISO 3166-2:BR',
    Independent: true,
  },
  {
    Country: 'British Indian Ocean Territory',
    'Alpha-2': 'IO',
    'Alpha-3': 'IOT',
    Numeric: 86,
    ISO: 'ISO 3166-2:IO',
    Independent: false,
  },
  {
    Country: 'Brunei Darussalam',
    'Alpha-2': 'BN',
    'Alpha-3': 'BRN',
    Numeric: 96,
    ISO: 'ISO 3166-2:BN',
    Independent: true,
  },
  {
    Country: 'Bulgaria',
    'Alpha-2': 'BG',
    'Alpha-3': 'BGR',
    Numeric: 100,
    ISO: 'ISO 3166-2:BG',
    Independent: true,
  },
  {
    Country: 'Burkina Faso',
    'Alpha-2': 'BF',
    'Alpha-3': 'BFA',
    Numeric: 854,
    ISO: 'ISO 3166-2:BF',
    Independent: true,
  },
  {
    Country: 'Burundi',
    'Alpha-2': 'BI',
    'Alpha-3': 'BDI',
    Numeric: 108,
    ISO: 'ISO 3166-2:BI',
    Independent: true,
  },
  {
    Country: 'Cabo Verde',
    'Alpha-2': 'CV',
    'Alpha-3': 'CPV',
    Numeric: 132,
    ISO: 'ISO 3166-2:CV',
    Independent: true,
  },
  {
    Country: 'Cambodia',
    'Alpha-2': 'KH',
    'Alpha-3': 'KHM',
    Numeric: 116,
    ISO: 'ISO 3166-2:KH',
    Independent: true,
  },
  {
    Country: 'Cameroon',
    'Alpha-2': 'CM',
    'Alpha-3': 'CMR',
    Numeric: 120,
    ISO: 'ISO 3166-2:CM',
    Independent: true,
  },
  {
    Country: 'Canada',
    'Alpha-2': 'CA',
    'Alpha-3': 'CAN',
    Numeric: 124,
    ISO: 'ISO 3166-2:CA',
    Independent: true,
  },
  {
    Country: 'Cayman Islands',
    'Alpha-2': 'KY',
    'Alpha-3': 'CYM',
    Numeric: 136,
    ISO: 'ISO 3166-2:KY',
    Independent: false,
  },
  {
    Country: 'Central African Republic',
    'Alpha-2': 'CF',
    'Alpha-3': 'CAF',
    Numeric: 140,
    ISO: 'ISO 3166-2:CF',
    Independent: true,
  },
  {
    Country: 'Chad',
    'Alpha-2': 'TD',
    'Alpha-3': 'TCD',
    Numeric: 148,
    ISO: 'ISO 3166-2:TD',
    Independent: true,
  },
  {
    Country: 'Chile',
    'Alpha-2': 'CL',
    'Alpha-3': 'CHL',
    Numeric: 152,
    ISO: 'ISO 3166-2:CL',
    Independent: true,
  },
  {
    Country: 'China',
    'Alpha-2': 'CN',
    'Alpha-3': 'CHN',
    Numeric: 156,
    ISO: 'ISO 3166-2:CN',
    Independent: true,
  },
  {
    Country: 'Christmas Island',
    'Alpha-2': 'CX',
    'Alpha-3': 'CXR',
    Numeric: 162,
    ISO: 'ISO 3166-2:CX',
    Independent: false,
  },
  {
    Country: 'Cocos (Keeling) Islands',
    'Alpha-2': 'CC',
    'Alpha-3': 'CCK',
    Numeric: 166,
    ISO: 'ISO 3166-2:CC',
    Independent: false,
  },
  {
    Country: 'Colombia',
    'Alpha-2': 'CO',
    'Alpha-3': 'COL',
    Numeric: 170,
    ISO: 'ISO 3166-2:CO',
    Independent: true,
  },
  {
    Country: 'Comoros',
    'Alpha-2': 'KM',
    'Alpha-3': 'COM',
    Numeric: 174,
    ISO: 'ISO 3166-2:KM',
    Independent: true,
  },
  {
    Country: 'Congo',
    'Alpha-2': 'CG',
    'Alpha-3': 'COG',
    Numeric: 178,
    ISO: 'ISO 3166-2:CG',
    Independent: true,
  },
  {
    Country: 'Congo, Democratic Republic of the',
    'Alpha-2': 'CD',
    'Alpha-3': 'COD',
    Numeric: 180,
    ISO: 'ISO 3166-2:CD',
    Independent: true,
  },
  {
    Country: 'Cook Islands',
    'Alpha-2': 'CK',
    'Alpha-3': 'COK',
    Numeric: 184,
    ISO: 'ISO 3166-2:CK',
    Independent: false,
  },
  {
    Country: 'Costa Rica',
    'Alpha-2': 'CR',
    'Alpha-3': 'CRI',
    Numeric: 188,
    ISO: 'ISO 3166-2:CR',
    Independent: true,
  },
  {
    Country: "C\u00f4te d'Ivoire",
    'Alpha-2': 'CI',
    'Alpha-3': 'CIV',
    Numeric: 384,
    ISO: 'ISO 3166-2:CI',
    Independent: true,
  },
  {
    Country: 'Croatia',
    'Alpha-2': 'HR',
    'Alpha-3': 'HRV',
    Numeric: 191,
    ISO: 'ISO 3166-2:HR',
    Independent: true,
  },
  {
    Country: 'Cuba',
    'Alpha-2': 'CU',
    'Alpha-3': 'CUB',
    Numeric: 192,
    ISO: 'ISO 3166-2:CU',
    Independent: true,
  },
  {
    Country: 'Cura\u00e7ao',
    'Alpha-2': 'CW',
    'Alpha-3': 'CUW',
    Numeric: 531,
    ISO: 'ISO 3166-2:CW',
    Independent: false,
  },
  {
    Country: 'Cyprus',
    'Alpha-2': 'CY',
    'Alpha-3': 'CYP',
    Numeric: 196,
    ISO: 'ISO 3166-2:CY',
    Independent: true,
  },
  {
    Country: 'Czechia',
    'Alpha-2': 'CZ',
    'Alpha-3': 'CZE',
    Numeric: 203,
    ISO: 'ISO 3166-2:CZ',
    Independent: true,
  },
  {
    Country: 'Denmark',
    'Alpha-2': 'DK',
    'Alpha-3': 'DNK',
    Numeric: 208,
    ISO: 'ISO 3166-2:DK',
    Independent: true,
  },
  {
    Country: 'Djibouti',
    'Alpha-2': 'DJ',
    'Alpha-3': 'DJI',
    Numeric: 262,
    ISO: 'ISO 3166-2:DJ',
    Independent: true,
  },
  {
    Country: 'Dominica',
    'Alpha-2': 'DM',
    'Alpha-3': 'DMA',
    Numeric: 212,
    ISO: 'ISO 3166-2:DM',
    Independent: true,
  },
  {
    Country: 'Dominican Republic',
    'Alpha-2': 'DO',
    'Alpha-3': 'DOM',
    Numeric: 214,
    ISO: 'ISO 3166-2:DO',
    Independent: true,
  },
  {
    Country: 'Ecuador',
    'Alpha-2': 'EC',
    'Alpha-3': 'ECU',
    Numeric: 218,
    ISO: 'ISO 3166-2:EC',
    Independent: true,
  },
  {
    Country: 'Egypt',
    'Alpha-2': 'EG',
    'Alpha-3': 'EGY',
    Numeric: 818,
    ISO: 'ISO 3166-2:EG',
    Independent: true,
  },
  {
    Country: 'El Salvador',
    'Alpha-2': 'SV',
    'Alpha-3': 'SLV',
    Numeric: 222,
    ISO: 'ISO 3166-2:SV',
    Independent: true,
  },
  {
    Country: 'Equatorial Guinea',
    'Alpha-2': 'GQ',
    'Alpha-3': 'GNQ',
    Numeric: 226,
    ISO: 'ISO 3166-2:GQ',
    Independent: true,
  },
  {
    Country: 'Eritrea',
    'Alpha-2': 'ER',
    'Alpha-3': 'ERI',
    Numeric: 232,
    ISO: 'ISO 3166-2:ER',
    Independent: true,
  },
  {
    Country: 'Estonia',
    'Alpha-2': 'EE',
    'Alpha-3': 'EST',
    Numeric: 233,
    ISO: 'ISO 3166-2:EE',
    Independent: true,
  },
  {
    Country: 'Eswatini',
    'Alpha-2': 'SZ',
    'Alpha-3': 'SWZ',
    Numeric: 748,
    ISO: 'ISO 3166-2:SZ',
    Independent: true,
  },
  {
    Country: 'Ethiopia',
    'Alpha-2': 'ET',
    'Alpha-3': 'ETH',
    Numeric: 231,
    ISO: 'ISO 3166-2:ET',
    Independent: true,
  },
  {
    Country: 'Falkland Islands (Malvinas)',
    'Alpha-2': 'FK',
    'Alpha-3': 'FLK',
    Numeric: 238,
    ISO: 'ISO 3166-2:FK',
    Independent: false,
  },
  {
    Country: 'Faroe Islands',
    'Alpha-2': 'FO',
    'Alpha-3': 'FRO',
    Numeric: 234,
    ISO: 'ISO 3166-2:FO',
    Independent: false,
  },
  {
    Country: 'Fiji',
    'Alpha-2': 'FJ',
    'Alpha-3': 'FJI',
    Numeric: 242,
    ISO: 'ISO 3166-2:FJ',
    Independent: true,
  },
  {
    Country: 'Finland',
    'Alpha-2': 'FI',
    'Alpha-3': 'FIN',
    Numeric: 246,
    ISO: 'ISO 3166-2:FI',
    Independent: true,
  },
  {
    Country: 'France',
    'Alpha-2': 'FR',
    'Alpha-3': 'FRA',
    Numeric: 250,
    ISO: 'ISO 3166-2:FR',
    Independent: true,
  },
  {
    Country: 'French Guiana',
    'Alpha-2': 'GF',
    'Alpha-3': 'GUF',
    Numeric: 254,
    ISO: 'ISO 3166-2:GF',
    Independent: false,
  },
  {
    Country: 'French Polynesia',
    'Alpha-2': 'PF',
    'Alpha-3': 'PYF',
    Numeric: 258,
    ISO: 'ISO 3166-2:PF',
    Independent: false,
  },
  {
    Country: 'French Southern Territories',
    'Alpha-2': 'TF',
    'Alpha-3': 'ATF',
    Numeric: 260,
    ISO: 'ISO 3166-2:TF',
    Independent: false,
  },
  {
    Country: 'Gabon',
    'Alpha-2': 'GA',
    'Alpha-3': 'GAB',
    Numeric: 266,
    ISO: 'ISO 3166-2:GA',
    Independent: true,
  },
  {
    Country: 'Gambia',
    'Alpha-2': 'GM',
    'Alpha-3': 'GMB',
    Numeric: 270,
    ISO: 'ISO 3166-2:GM',
    Independent: true,
  },
  {
    Country: 'Georgia',
    'Alpha-2': 'GE',
    'Alpha-3': 'GEO',
    Numeric: 268,
    ISO: 'ISO 3166-2:GE',
    Independent: true,
  },
  {
    Country: 'Germany',
    'Alpha-2': 'DE',
    'Alpha-3': 'DEU',
    Numeric: 276,
    ISO: 'ISO 3166-2:DE',
    Independent: true,
  },
  {
    Country: 'Ghana',
    'Alpha-2': 'GH',
    'Alpha-3': 'GHA',
    Numeric: 288,
    ISO: 'ISO 3166-2:GH',
    Independent: true,
  },
  {
    Country: 'Gibraltar',
    'Alpha-2': 'GI',
    'Alpha-3': 'GIB',
    Numeric: 292,
    ISO: 'ISO 3166-2:GI',
    Independent: false,
  },
  {
    Country: 'Greece',
    'Alpha-2': 'GR',
    'Alpha-3': 'GRC',
    Numeric: 300,
    ISO: 'ISO 3166-2:GR',
    Independent: true,
  },
  {
    Country: 'Greenland',
    'Alpha-2': 'GL',
    'Alpha-3': 'GRL',
    Numeric: 304,
    ISO: 'ISO 3166-2:GL',
    Independent: false,
  },
  {
    Country: 'Grenada',
    'Alpha-2': 'GD',
    'Alpha-3': 'GRD',
    Numeric: 308,
    ISO: 'ISO 3166-2:GD',
    Independent: true,
  },
  {
    Country: 'Guadeloupe',
    'Alpha-2': 'GP',
    'Alpha-3': 'GLP',
    Numeric: 312,
    ISO: 'ISO 3166-2:GP',
    Independent: false,
  },
  {
    Country: 'Guam',
    'Alpha-2': 'GU',
    'Alpha-3': 'GUM',
    Numeric: 316,
    ISO: 'ISO 3166-2:GU',
    Independent: false,
  },
  {
    Country: 'Guatemala',
    'Alpha-2': 'GT',
    'Alpha-3': 'GTM',
    Numeric: 320,
    ISO: 'ISO 3166-2:GT',
    Independent: true,
  },
  {
    Country: 'Guernsey',
    'Alpha-2': 'GG',
    'Alpha-3': 'GGY',
    Numeric: 831,
    ISO: 'ISO 3166-2:GG',
    Independent: false,
  },
  {
    Country: 'Guinea',
    'Alpha-2': 'GN',
    'Alpha-3': 'GIN',
    Numeric: 324,
    ISO: 'ISO 3166-2:GN',
    Independent: true,
  },
  {
    Country: 'Guinea-Bissau',
    'Alpha-2': 'GW',
    'Alpha-3': 'GNB',
    Numeric: 624,
    ISO: 'ISO 3166-2:GW',
    Independent: true,
  },
  {
    Country: 'Guyana',
    'Alpha-2': 'GY',
    'Alpha-3': 'GUY',
    Numeric: 328,
    ISO: 'ISO 3166-2:GY',
    Independent: true,
  },
  {
    Country: 'Haiti',
    'Alpha-2': 'HT',
    'Alpha-3': 'HTI',
    Numeric: 332,
    ISO: 'ISO 3166-2:HT',
    Independent: true,
  },
  {
    Country: 'Heard Island and McDonald Islands',
    'Alpha-2': 'HM',
    'Alpha-3': 'HMD',
    Numeric: 334,
    ISO: 'ISO 3166-2:HM',
    Independent: false,
  },
  {
    Country: 'Holy See',
    'Alpha-2': 'VA',
    'Alpha-3': 'VAT',
    Numeric: 336,
    ISO: 'ISO 3166-2:VA',
    Independent: true,
  },
  {
    Country: 'Honduras',
    'Alpha-2': 'HN',
    'Alpha-3': 'HND',
    Numeric: 340,
    ISO: 'ISO 3166-2:HN',
    Independent: true,
  },
  {
    Country: 'Hong Kong',
    'Alpha-2': 'HK',
    'Alpha-3': 'HKG',
    Numeric: 344,
    ISO: 'ISO 3166-2:HK',
    Independent: false,
  },
  {
    Country: 'Hungary',
    'Alpha-2': 'HU',
    'Alpha-3': 'HUN',
    Numeric: 348,
    ISO: 'ISO 3166-2:HU',
    Independent: true,
  },
  {
    Country: 'Iceland',
    'Alpha-2': 'IS',
    'Alpha-3': 'ISL',
    Numeric: 352,
    ISO: 'ISO 3166-2:IS',
    Independent: true,
  },
  {
    Country: 'India',
    'Alpha-2': 'IN',
    'Alpha-3': 'IND',
    Numeric: 356,
    ISO: 'ISO 3166-2:IN',
    Independent: true,
  },
  {
    Country: 'Indonesia',
    'Alpha-2': 'ID',
    'Alpha-3': 'IDN',
    Numeric: 360,
    ISO: 'ISO 3166-2:ID',
    Independent: true,
  },
  {
    Country: 'Iran, Islamic Republic of',
    'Alpha-2': 'IR',
    'Alpha-3': 'IRN',
    Numeric: 364,
    ISO: 'ISO 3166-2:IR',
    Independent: true,
  },
  {
    Country: 'Iraq',
    'Alpha-2': 'IQ',
    'Alpha-3': 'IRQ',
    Numeric: 368,
    ISO: 'ISO 3166-2:IQ',
    Independent: true,
  },
  {
    Country: 'Ireland',
    'Alpha-2': 'IE',
    'Alpha-3': 'IRL',
    Numeric: 372,
    ISO: 'ISO 3166-2:IE',
    Independent: true,
  },
  {
    Country: 'Isle of Man',
    'Alpha-2': 'IM',
    'Alpha-3': 'IMN',
    Numeric: 833,
    ISO: 'ISO 3166-2:IM',
    Independent: false,
  },
  {
    Country: 'Israel',
    'Alpha-2': 'IL',
    'Alpha-3': 'ISR',
    Numeric: 376,
    ISO: 'ISO 3166-2:IL',
    Independent: true,
  },
  {
    Country: 'Italy',
    'Alpha-2': 'IT',
    'Alpha-3': 'ITA',
    Numeric: 380,
    ISO: 'ISO 3166-2:IT',
    Independent: true,
  },
  {
    Country: 'Jamaica',
    'Alpha-2': 'JM',
    'Alpha-3': 'JAM',
    Numeric: 388,
    ISO: 'ISO 3166-2:JM',
    Independent: true,
  },
  {
    Country: 'Japan',
    'Alpha-2': 'JP',
    'Alpha-3': 'JPN',
    Numeric: 392,
    ISO: 'ISO 3166-2:JP',
    Independent: true,
  },
  {
    Country: 'Jersey',
    'Alpha-2': 'JE',
    'Alpha-3': 'JEY',
    Numeric: 832,
    ISO: 'ISO 3166-2:JE',
    Independent: false,
  },
  {
    Country: 'Jordan',
    'Alpha-2': 'JO',
    'Alpha-3': 'JOR',
    Numeric: 400,
    ISO: 'ISO 3166-2:JO',
    Independent: true,
  },
  {
    Country: 'Kazakhstan',
    'Alpha-2': 'KZ',
    'Alpha-3': 'KAZ',
    Numeric: 398,
    ISO: 'ISO 3166-2:KZ',
    Independent: true,
  },
  {
    Country: 'Kenya',
    'Alpha-2': 'KE',
    'Alpha-3': 'KEN',
    Numeric: 404,
    ISO: 'ISO 3166-2:KE',
    Independent: true,
  },
  {
    Country: 'Kiribati',
    'Alpha-2': 'KI',
    'Alpha-3': 'KIR',
    Numeric: 296,
    ISO: 'ISO 3166-2:KI',
    Independent: true,
  },
  {
    Country: "Korea, Democratic People's Republic of",
    'Alpha-2': 'KP',
    'Alpha-3': 'PRK',
    Numeric: 408,
    ISO: 'ISO 3166-2:KP',
    Independent: true,
  },
  {
    Country: 'Korea, Republic of',
    'Alpha-2': 'KR',
    'Alpha-3': 'KOR',
    Numeric: 410,
    ISO: 'ISO 3166-2:KR',
    Independent: true,
  },
  {
    Country: 'Kuwait',
    'Alpha-2': 'KW',
    'Alpha-3': 'KWT',
    Numeric: 414,
    ISO: 'ISO 3166-2:KW',
    Independent: true,
  },
  {
    Country: 'Kyrgyzstan',
    'Alpha-2': 'KG',
    'Alpha-3': 'KGZ',
    Numeric: 417,
    ISO: 'ISO 3166-2:KG',
    Independent: true,
  },
  {
    Country: "Lao People's Democratic Republic",
    'Alpha-2': 'LA',
    'Alpha-3': 'LAO',
    Numeric: 418,
    ISO: 'ISO 3166-2:LA',
    Independent: true,
  },
  {
    Country: 'Latvia',
    'Alpha-2': 'LV',
    'Alpha-3': 'LVA',
    Numeric: 428,
    ISO: 'ISO 3166-2:LV',
    Independent: true,
  },
  {
    Country: 'Lebanon',
    'Alpha-2': 'LB',
    'Alpha-3': 'LBN',
    Numeric: 422,
    ISO: 'ISO 3166-2:LB',
    Independent: true,
  },
  {
    Country: 'Lesotho',
    'Alpha-2': 'LS',
    'Alpha-3': 'LSO',
    Numeric: 426,
    ISO: 'ISO 3166-2:LS',
    Independent: true,
  },
  {
    Country: 'Liberia',
    'Alpha-2': 'LR',
    'Alpha-3': 'LBR',
    Numeric: 430,
    ISO: 'ISO 3166-2:LR',
    Independent: true,
  },
  {
    Country: 'Libya',
    'Alpha-2': 'LY',
    'Alpha-3': 'LBY',
    Numeric: 434,
    ISO: 'ISO 3166-2:LY',
    Independent: true,
  },
  {
    Country: 'Liechtenstein',
    'Alpha-2': 'LI',
    'Alpha-3': 'LIE',
    Numeric: 438,
    ISO: 'ISO 3166-2:LI',
    Independent: true,
  },
  {
    Country: 'Lithuania',
    'Alpha-2': 'LT',
    'Alpha-3': 'LTU',
    Numeric: 440,
    ISO: 'ISO 3166-2:LT',
    Independent: true,
  },
  {
    Country: 'Luxembourg',
    'Alpha-2': 'LU',
    'Alpha-3': 'LUX',
    Numeric: 442,
    ISO: 'ISO 3166-2:LU',
    Independent: true,
  },
  {
    Country: 'Macao',
    'Alpha-2': 'MO',
    'Alpha-3': 'MAC',
    Numeric: 446,
    ISO: 'ISO 3166-2:MO',
    Independent: false,
  },
  {
    Country: 'Madagascar',
    'Alpha-2': 'MG',
    'Alpha-3': 'MDG',
    Numeric: 450,
    ISO: 'ISO 3166-2:MG',
    Independent: true,
  },
  {
    Country: 'Malawi',
    'Alpha-2': 'MW',
    'Alpha-3': 'MWI',
    Numeric: 454,
    ISO: 'ISO 3166-2:MW',
    Independent: true,
  },
  {
    Country: 'Malaysia',
    'Alpha-2': 'MY',
    'Alpha-3': 'MYS',
    Numeric: 458,
    ISO: 'ISO 3166-2:MY',
    Independent: true,
  },
  {
    Country: 'Maldives',
    'Alpha-2': 'MV',
    'Alpha-3': 'MDV',
    Numeric: 462,
    ISO: 'ISO 3166-2:MV',
    Independent: true,
  },
  {
    Country: 'Mali',
    'Alpha-2': 'ML',
    'Alpha-3': 'MLI',
    Numeric: 466,
    ISO: 'ISO 3166-2:ML',
    Independent: true,
  },
  {
    Country: 'Malta',
    'Alpha-2': 'MT',
    'Alpha-3': 'MLT',
    Numeric: 470,
    ISO: 'ISO 3166-2:MT',
    Independent: true,
  },
  {
    Country: 'Marshall Islands',
    'Alpha-2': 'MH',
    'Alpha-3': 'MHL',
    Numeric: 584,
    ISO: 'ISO 3166-2:MH',
    Independent: true,
  },
  {
    Country: 'Martinique',
    'Alpha-2': 'MQ',
    'Alpha-3': 'MTQ',
    Numeric: 474,
    ISO: 'ISO 3166-2:MQ',
    Independent: false,
  },
  {
    Country: 'Mauritania',
    'Alpha-2': 'MR',
    'Alpha-3': 'MRT',
    Numeric: 478,
    ISO: 'ISO 3166-2:MR',
    Independent: true,
  },
  {
    Country: 'Mauritius',
    'Alpha-2': 'MU',
    'Alpha-3': 'MUS',
    Numeric: 480,
    ISO: 'ISO 3166-2:MU',
    Independent: true,
  },
  {
    Country: 'Mayotte',
    'Alpha-2': 'YT',
    'Alpha-3': 'MYT',
    Numeric: 175,
    ISO: 'ISO 3166-2:YT',
    Independent: false,
  },
  {
    Country: 'Mexico',
    'Alpha-2': 'MX',
    'Alpha-3': 'MEX',
    Numeric: 484,
    ISO: 'ISO 3166-2:MX',
    Independent: true,
  },
  {
    Country: 'Micronesia, Federated States of',
    'Alpha-2': 'FM',
    'Alpha-3': 'FSM',
    Numeric: 583,
    ISO: 'ISO 3166-2:FM',
    Independent: true,
  },
  {
    Country: 'Moldova, Republic of',
    'Alpha-2': 'MD',
    'Alpha-3': 'MDA',
    Numeric: 498,
    ISO: 'ISO 3166-2:MD',
    Independent: true,
  },
  {
    Country: 'Monaco',
    'Alpha-2': 'MC',
    'Alpha-3': 'MCO',
    Numeric: 492,
    ISO: 'ISO 3166-2:MC',
    Independent: true,
  },
  {
    Country: 'Mongolia',
    'Alpha-2': 'MN',
    'Alpha-3': 'MNG',
    Numeric: 496,
    ISO: 'ISO 3166-2:MN',
    Independent: true,
  },
  {
    Country: 'Montenegro',
    'Alpha-2': 'ME',
    'Alpha-3': 'MNE',
    Numeric: 499,
    ISO: 'ISO 3166-2:ME',
    Independent: true,
  },
  {
    Country: 'Montserrat',
    'Alpha-2': 'MS',
    'Alpha-3': 'MSR',
    Numeric: 500,
    ISO: 'ISO 3166-2:MS',
    Independent: false,
  },
  {
    Country: 'Morocco',
    'Alpha-2': 'MA',
    'Alpha-3': 'MAR',
    Numeric: 504,
    ISO: 'ISO 3166-2:MA',
    Independent: true,
  },
  {
    Country: 'Mozambique',
    'Alpha-2': 'MZ',
    'Alpha-3': 'MOZ',
    Numeric: 508,
    ISO: 'ISO 3166-2:MZ',
    Independent: true,
  },
  {
    Country: 'Myanmar',
    'Alpha-2': 'MM',
    'Alpha-3': 'MMR',
    Numeric: 104,
    ISO: 'ISO 3166-2:MM',
    Independent: true,
  },
  {
    Country: 'Namibia',
    'Alpha-2': 'NA',
    'Alpha-3': 'NAM',
    Numeric: 516,
    ISO: 'ISO 3166-2:NA',
    Independent: true,
  },
  {
    Country: 'Nauru',
    'Alpha-2': 'NR',
    'Alpha-3': 'NRU',
    Numeric: 520,
    ISO: 'ISO 3166-2:NR',
    Independent: true,
  },
  {
    Country: 'Nepal',
    'Alpha-2': 'NP',
    'Alpha-3': 'NPL',
    Numeric: 524,
    ISO: 'ISO 3166-2:NP',
    Independent: true,
  },
  {
    Country: 'Netherlands',
    'Alpha-2': 'NL',
    'Alpha-3': 'NLD',
    Numeric: 528,
    ISO: 'ISO 3166-2:NL',
    Independent: true,
  },
  {
    Country: 'New Caledonia',
    'Alpha-2': 'NC',
    'Alpha-3': 'NCL',
    Numeric: 540,
    ISO: 'ISO 3166-2:NC',
    Independent: false,
  },
  {
    Country: 'New Zealand',
    'Alpha-2': 'NZ',
    'Alpha-3': 'NZL',
    Numeric: 554,
    ISO: 'ISO 3166-2:NZ',
    Independent: true,
  },
  {
    Country: 'Nicaragua',
    'Alpha-2': 'NI',
    'Alpha-3': 'NIC',
    Numeric: 558,
    ISO: 'ISO 3166-2:NI',
    Independent: true,
  },
  {
    Country: 'Niger',
    'Alpha-2': 'NE',
    'Alpha-3': 'NER',
    Numeric: 562,
    ISO: 'ISO 3166-2:NE',
    Independent: true,
  },
  {
    Country: 'Nigeria',
    'Alpha-2': 'NG',
    'Alpha-3': 'NGA',
    Numeric: 566,
    ISO: 'ISO 3166-2:NG',
    Independent: true,
  },
  {
    Country: 'Niue',
    'Alpha-2': 'NU',
    'Alpha-3': 'NIU',
    Numeric: 570,
    ISO: 'ISO 3166-2:NU',
    Independent: false,
  },
  {
    Country: 'Norfolk Island',
    'Alpha-2': 'NF',
    'Alpha-3': 'NFK',
    Numeric: 574,
    ISO: 'ISO 3166-2:NF',
    Independent: false,
  },
  {
    Country: 'North Macedonia',
    'Alpha-2': 'MK',
    'Alpha-3': 'MKD',
    Numeric: 807,
    ISO: 'ISO 3166-2:MK',
    Independent: true,
  },
  {
    Country: 'Northern Mariana Islands',
    'Alpha-2': 'MP',
    'Alpha-3': 'MNP',
    Numeric: 580,
    ISO: 'ISO 3166-2:MP',
    Independent: false,
  },
  {
    Country: 'Norway',
    'Alpha-2': 'NO',
    'Alpha-3': 'NOR',
    Numeric: 578,
    ISO: 'ISO 3166-2:NO',
    Independent: true,
  },
  {
    Country: 'Oman',
    'Alpha-2': 'OM',
    'Alpha-3': 'OMN',
    Numeric: 512,
    ISO: 'ISO 3166-2:OM',
    Independent: true,
  },
  {
    Country: 'Pakistan',
    'Alpha-2': 'PK',
    'Alpha-3': 'PAK',
    Numeric: 586,
    ISO: 'ISO 3166-2:PK',
    Independent: true,
  },
  {
    Country: 'Palau',
    'Alpha-2': 'PW',
    'Alpha-3': 'PLW',
    Numeric: 585,
    ISO: 'ISO 3166-2:PW',
    Independent: true,
  },
  {
    Country: 'Palestine, State of',
    'Alpha-2': 'PS',
    'Alpha-3': 'PSE',
    Numeric: 275,
    ISO: 'ISO 3166-2:PS',
    Independent: false,
  },
  {
    Country: 'Panama',
    'Alpha-2': 'PA',
    'Alpha-3': 'PAN',
    Numeric: 591,
    ISO: 'ISO 3166-2:PA',
    Independent: true,
  },
  {
    Country: 'Papua New Guinea',
    'Alpha-2': 'PG',
    'Alpha-3': 'PNG',
    Numeric: 598,
    ISO: 'ISO 3166-2:PG',
    Independent: true,
  },
  {
    Country: 'Paraguay',
    'Alpha-2': 'PY',
    'Alpha-3': 'PRY',
    Numeric: 600,
    ISO: 'ISO 3166-2:PY',
    Independent: true,
  },
  {
    Country: 'Peru',
    'Alpha-2': 'PE',
    'Alpha-3': 'PER',
    Numeric: 604,
    ISO: 'ISO 3166-2:PE',
    Independent: true,
  },
  {
    Country: 'Philippines',
    'Alpha-2': 'PH',
    'Alpha-3': 'PHL',
    Numeric: 608,
    ISO: 'ISO 3166-2:PH',
    Independent: true,
  },
  {
    Country: 'Pitcairn',
    'Alpha-2': 'PN',
    'Alpha-3': 'PCN',
    Numeric: 612,
    ISO: 'ISO 3166-2:PN',
    Independent: false,
  },
  {
    Country: 'Poland',
    'Alpha-2': 'PL',
    'Alpha-3': 'POL',
    Numeric: 616,
    ISO: 'ISO 3166-2:PL',
    Independent: true,
  },
  {
    Country: 'Portugal',
    'Alpha-2': 'PT',
    'Alpha-3': 'PRT',
    Numeric: 620,
    ISO: 'ISO 3166-2:PT',
    Independent: true,
  },
  {
    Country: 'Puerto Rico',
    'Alpha-2': 'PR',
    'Alpha-3': 'PRI',
    Numeric: 630,
    ISO: 'ISO 3166-2:PR',
    Independent: false,
  },
  {
    Country: 'Qatar',
    'Alpha-2': 'QA',
    'Alpha-3': 'QAT',
    Numeric: 634,
    ISO: 'ISO 3166-2:QA',
    Independent: true,
  },
  {
    Country: 'R\u00e9union',
    'Alpha-2': 'RE',
    'Alpha-3': 'REU',
    Numeric: 638,
    ISO: 'ISO 3166-2:RE',
    Independent: false,
  },
  {
    Country: 'Romania',
    'Alpha-2': 'RO',
    'Alpha-3': 'ROU',
    Numeric: 642,
    ISO: 'ISO 3166-2:RO',
    Independent: true,
  },
  {
    Country: 'Russian Federation',
    'Alpha-2': 'RU',
    'Alpha-3': 'RUS',
    Numeric: 643,
    ISO: 'ISO 3166-2:RU',
    Independent: true,
  },
  {
    Country: 'Rwanda',
    'Alpha-2': 'RW',
    'Alpha-3': 'RWA',
    Numeric: 646,
    ISO: 'ISO 3166-2:RW',
    Independent: true,
  },
  {
    Country: 'Saint Barth\u00e9lemy',
    'Alpha-2': 'BL',
    'Alpha-3': 'BLM',
    Numeric: 652,
    ISO: 'ISO 3166-2:BL',
    Independent: false,
  },
  {
    Country: 'Saint Helena, Ascension and Tristan da Cunha',
    'Alpha-2': 'SH',
    'Alpha-3': 'SHN',
    Numeric: 654,
    ISO: 'ISO 3166-2:SH',
    Independent: false,
  },
  {
    Country: 'Saint Kitts and Nevis',
    'Alpha-2': 'KN',
    'Alpha-3': 'KNA',
    Numeric: 659,
    ISO: 'ISO 3166-2:KN',
    Independent: true,
  },
  {
    Country: 'Saint Lucia',
    'Alpha-2': 'LC',
    'Alpha-3': 'LCA',
    Numeric: 662,
    ISO: 'ISO 3166-2:LC',
    Independent: true,
  },
  {
    Country: 'Saint Martin (French part)',
    'Alpha-2': 'MF',
    'Alpha-3': 'MAF',
    Numeric: 663,
    ISO: 'ISO 3166-2:MF',
    Independent: false,
  },
  {
    Country: 'Saint Pierre and Miquelon',
    'Alpha-2': 'PM',
    'Alpha-3': 'SPM',
    Numeric: 666,
    ISO: 'ISO 3166-2:PM',
    Independent: false,
  },
  {
    Country: 'Saint Vincent and the Grenadines',
    'Alpha-2': 'VC',
    'Alpha-3': 'VCT',
    Numeric: 670,
    ISO: 'ISO 3166-2:VC',
    Independent: true,
  },
  {
    Country: 'Samoa',
    'Alpha-2': 'WS',
    'Alpha-3': 'WSM',
    Numeric: 882,
    ISO: 'ISO 3166-2:WS',
    Independent: true,
  },
  {
    Country: 'San Marino',
    'Alpha-2': 'SM',
    'Alpha-3': 'SMR',
    Numeric: 674,
    ISO: 'ISO 3166-2:SM',
    Independent: true,
  },
  {
    Country: 'Sao Tome and Principe',
    'Alpha-2': 'ST',
    'Alpha-3': 'STP',
    Numeric: 678,
    ISO: 'ISO 3166-2:ST',
    Independent: true,
  },
  {
    Country: 'Saudi Arabia',
    'Alpha-2': 'SA',
    'Alpha-3': 'SAU',
    Numeric: 682,
    ISO: 'ISO 3166-2:SA',
    Independent: true,
  },
  {
    Country: 'Senegal',
    'Alpha-2': 'SN',
    'Alpha-3': 'SEN',
    Numeric: 686,
    ISO: 'ISO 3166-2:SN',
    Independent: true,
  },
  {
    Country: 'Serbia',
    'Alpha-2': 'RS',
    'Alpha-3': 'SRB',
    Numeric: 688,
    ISO: 'ISO 3166-2:RS',
    Independent: true,
  },
  {
    Country: 'Seychelles',
    'Alpha-2': 'SC',
    'Alpha-3': 'SYC',
    Numeric: 690,
    ISO: 'ISO 3166-2:SC',
    Independent: true,
  },
  {
    Country: 'Sierra Leone',
    'Alpha-2': 'SL',
    'Alpha-3': 'SLE',
    Numeric: 694,
    ISO: 'ISO 3166-2:SL',
    Independent: true,
  },
  {
    Country: 'Singapore',
    'Alpha-2': 'SG',
    'Alpha-3': 'SGP',
    Numeric: 702,
    ISO: 'ISO 3166-2:SG',
    Independent: true,
  },
  {
    Country: 'Sint Maarten (Dutch part)',
    'Alpha-2': 'SX',
    'Alpha-3': 'SXM',
    Numeric: 534,
    ISO: 'ISO 3166-2:SX',
    Independent: false,
  },
  {
    Country: 'Slovakia',
    'Alpha-2': 'SK',
    'Alpha-3': 'SVK',
    Numeric: 703,
    ISO: 'ISO 3166-2:SK',
    Independent: true,
  },
  {
    Country: 'Slovenia',
    'Alpha-2': 'SI',
    'Alpha-3': 'SVN',
    Numeric: 705,
    ISO: 'ISO 3166-2:SI',
    Independent: true,
  },
  {
    Country: 'Solomon Islands',
    'Alpha-2': 'SB',
    'Alpha-3': 'SLB',
    Numeric: 90,
    ISO: 'ISO 3166-2:SB',
    Independent: true,
  },
  {
    Country: 'Somalia',
    'Alpha-2': 'SO',
    'Alpha-3': 'SOM',
    Numeric: 706,
    ISO: 'ISO 3166-2:SO',
    Independent: true,
  },
  {
    Country: 'South Africa',
    'Alpha-2': 'ZA',
    'Alpha-3': 'ZAF',
    Numeric: 710,
    ISO: 'ISO 3166-2:ZA',
    Independent: true,
  },
  {
    Country: 'South Georgia and the South Sandwich Islands',
    'Alpha-2': 'GS',
    'Alpha-3': 'SGS',
    Numeric: 239,
    ISO: 'ISO 3166-2:GS',
    Independent: false,
  },
  {
    Country: 'South Sudan',
    'Alpha-2': 'SS',
    'Alpha-3': 'SSD',
    Numeric: 728,
    ISO: 'ISO 3166-2:SS',
    Independent: true,
  },
  {
    Country: 'Spain',
    'Alpha-2': 'ES',
    'Alpha-3': 'ESP',
    Numeric: 724,
    ISO: 'ISO 3166-2:ES',
    Independent: true,
  },
  {
    Country: 'Sri Lanka',
    'Alpha-2': 'LK',
    'Alpha-3': 'LKA',
    Numeric: 144,
    ISO: 'ISO 3166-2:LK',
    Independent: true,
  },
  {
    Country: 'Sudan',
    'Alpha-2': 'SD',
    'Alpha-3': 'SDN',
    Numeric: 729,
    ISO: 'ISO 3166-2:SD',
    Independent: true,
  },
  {
    Country: 'Suriname',
    'Alpha-2': 'SR',
    'Alpha-3': 'SUR',
    Numeric: 740,
    ISO: 'ISO 3166-2:SR',
    Independent: true,
  },
  {
    Country: 'Svalbard and Jan Mayen',
    'Alpha-2': 'SJ',
    'Alpha-3': 'SJM',
    Numeric: 744,
    ISO: 'ISO 3166-2:SJ',
    Independent: false,
  },
  {
    Country: 'Sweden',
    'Alpha-2': 'SE',
    'Alpha-3': 'SWE',
    Numeric: 752,
    ISO: 'ISO 3166-2:SE',
    Independent: true,
  },
  {
    Country: 'Switzerland',
    'Alpha-2': 'CH',
    'Alpha-3': 'CHE',
    Numeric: 756,
    ISO: 'ISO 3166-2:CH',
    Independent: true,
  },
  {
    Country: 'Syrian Arab Republic',
    'Alpha-2': 'SY',
    'Alpha-3': 'SYR',
    Numeric: 760,
    ISO: 'ISO 3166-2:SY',
    Independent: true,
  },
  {
    Country: 'Taiwan, Province of China',
    'Alpha-2': 'TW',
    'Alpha-3': 'TWN',
    Numeric: 158,
    ISO: 'ISO 3166-2:TW',
    Independent: false,
  },
  {
    Country: 'Tajikistan',
    'Alpha-2': 'TJ',
    'Alpha-3': 'TJK',
    Numeric: 762,
    ISO: 'ISO 3166-2:TJ',
    Independent: true,
  },
  {
    Country: 'Tanzania, United Republic of',
    'Alpha-2': 'TZ',
    'Alpha-3': 'TZA',
    Numeric: 834,
    ISO: 'ISO 3166-2:TZ',
    Independent: true,
  },
  {
    Country: 'Thailand',
    'Alpha-2': 'TH',
    'Alpha-3': 'THA',
    Numeric: 764,
    ISO: 'ISO 3166-2:TH',
    Independent: true,
  },
  {
    Country: 'Timor-Leste',
    'Alpha-2': 'TL',
    'Alpha-3': 'TLS',
    Numeric: 626,
    ISO: 'ISO 3166-2:TL',
    Independent: true,
  },
  {
    Country: 'Togo',
    'Alpha-2': 'TG',
    'Alpha-3': 'TGO',
    Numeric: 768,
    ISO: 'ISO 3166-2:TG',
    Independent: true,
  },
  {
    Country: 'Tokelau',
    'Alpha-2': 'TK',
    'Alpha-3': 'TKL',
    Numeric: 772,
    ISO: 'ISO 3166-2:TK',
    Independent: false,
  },
  {
    Country: 'Tonga',
    'Alpha-2': 'TO',
    'Alpha-3': 'TON',
    Numeric: 776,
    ISO: 'ISO 3166-2:TO',
    Independent: true,
  },
  {
    Country: 'Trinidad and Tobago',
    'Alpha-2': 'TT',
    'Alpha-3': 'TTO',
    Numeric: 780,
    ISO: 'ISO 3166-2:TT',
    Independent: true,
  },
  {
    Country: 'Tunisia',
    'Alpha-2': 'TN',
    'Alpha-3': 'TUN',
    Numeric: 788,
    ISO: 'ISO 3166-2:TN',
    Independent: true,
  },
  {
    Country: 'T\u00fcrkiye',
    'Alpha-2': 'TR',
    'Alpha-3': 'TUR',
    Numeric: 792,
    ISO: 'ISO 3166-2:TR',
    Independent: true,
  },
  {
    Country: 'Turkmenistan',
    'Alpha-2': 'TM',
    'Alpha-3': 'TKM',
    Numeric: 795,
    ISO: 'ISO 3166-2:TM',
    Independent: true,
  },
  {
    Country: 'Turks and Caicos Islands',
    'Alpha-2': 'TC',
    'Alpha-3': 'TCA',
    Numeric: 796,
    ISO: 'ISO 3166-2:TC',
    Independent: false,
  },
  {
    Country: 'Tuvalu',
    'Alpha-2': 'TV',
    'Alpha-3': 'TUV',
    Numeric: 798,
    ISO: 'ISO 3166-2:TV',
    Independent: true,
  },
  {
    Country: 'Uganda',
    'Alpha-2': 'UG',
    'Alpha-3': 'UGA',
    Numeric: 800,
    ISO: 'ISO 3166-2:UG',
    Independent: true,
  },
  {
    Country: 'Ukraine',
    'Alpha-2': 'UA',
    'Alpha-3': 'UKR',
    Numeric: 804,
    ISO: 'ISO 3166-2:UA',
    Independent: true,
  },
  {
    Country: 'United Arab Emirates',
    'Alpha-2': 'AE',
    'Alpha-3': 'ARE',
    Numeric: 784,
    ISO: 'ISO 3166-2:AE',
    Independent: true,
  },
  {
    Country: 'United Kingdom of Great Britain and Northern Ireland',
    'Alpha-2': 'GB',
    'Alpha-3': 'GBR',
    Numeric: 826,
    ISO: 'ISO 3166-2:GB',
    Independent: true,
  },
  {
    Country: 'United States of America',
    'Alpha-2': 'US',
    'Alpha-3': 'USA',
    Numeric: 840,
    ISO: 'ISO 3166-2:US',
    Independent: true,
  },
  {
    Country: 'United States Minor Outlying Islands',
    'Alpha-2': 'UM',
    'Alpha-3': 'UMI',
    Numeric: 581,
    ISO: 'ISO 3166-2:UM',
    Independent: false,
  },
  {
    Country: 'Uruguay',
    'Alpha-2': 'UY',
    'Alpha-3': 'URY',
    Numeric: 858,
    ISO: 'ISO 3166-2:UY',
    Independent: true,
  },
  {
    Country: 'Uzbekistan',
    'Alpha-2': 'UZ',
    'Alpha-3': 'UZB',
    Numeric: 860,
    ISO: 'ISO 3166-2:UZ',
    Independent: true,
  },
  {
    Country: 'Vanuatu',
    'Alpha-2': 'VU',
    'Alpha-3': 'VUT',
    Numeric: 548,
    ISO: 'ISO 3166-2:VU',
    Independent: true,
  },
  {
    Country: 'Venezuela, Bolivarian Republic of',
    'Alpha-2': 'VE',
    'Alpha-3': 'VEN',
    Numeric: 862,
    ISO: 'ISO 3166-2:VE',
    Independent: true,
  },
  {
    Country: 'Viet Nam',
    'Alpha-2': 'VN',
    'Alpha-3': 'VNM',
    Numeric: 704,
    ISO: 'ISO 3166-2:VN',
    Independent: true,
  },
  {
    Country: 'Virgin Islands (British)',
    'Alpha-2': 'VG',
    'Alpha-3': 'VGB',
    Numeric: 92,
    ISO: 'ISO 3166-2:VG',
    Independent: false,
  },
  {
    Country: 'Virgin Islands (U.S.)',
    'Alpha-2': 'VI',
    'Alpha-3': 'VIR',
    Numeric: 850,
    ISO: 'ISO 3166-2:VI',
    Independent: false,
  },
  {
    Country: 'Wallis and Futuna',
    'Alpha-2': 'WF',
    'Alpha-3': 'WLF',
    Numeric: 876,
    ISO: 'ISO 3166-2:WF',
    Independent: false,
  },
  {
    Country: 'Western Sahara',
    'Alpha-2': 'EH',
    'Alpha-3': 'ESH',
    Numeric: 732,
    ISO: 'ISO 3166-2:EH',
    Independent: false,
  },
  {
    Country: 'Yemen',
    'Alpha-2': 'YE',
    'Alpha-3': 'YEM',
    Numeric: 887,
    ISO: 'ISO 3166-2:YE',
    Independent: true,
  },
  {
    Country: 'Zambia',
    'Alpha-2': 'ZM',
    'Alpha-3': 'ZMB',
    Numeric: 894,
    ISO: 'ISO 3166-2:ZM',
    Independent: true,
  },
  {
    Country: 'Zimbabwe',
    'Alpha-2': 'ZW',
    'Alpha-3': 'ZWE',
    Numeric: 716,
    ISO: 'ISO 3166-2:ZW',
    Independent: true,
  },
];
